import React, { useState, useEffect } from "react";
// import slider01 from '/catalog/letter_penoplant/01.jpg';
// import slider02 from '/catalog/letter_penoplant/02.jpg';
// import slider03 from '/catalog/letter_penoplant/03.jpg';
// import slider04 from '/catalog/letter_penoplant/04.jpg';
import slider01 from '../../assets/two_slider_1.avif';
import slider02 from '../../assets/two_slider_2.avif';
import slider03 from '../../assets/two_slider_3.avif';
import slider04 from '../../assets/two_slider_4.avif';
const slidesData = [
  {
    badge: "Акция месяца",
    title: "Попробуйте 2 или более продукта — бесплатная доставка",
    description: "Получите бесплатную экономичную доставку при заказе как минимум 2 разных продуктов: визитки, футболки, наклейки, виниловые баннеры, стикеры, открытки, таблички, ручки и постеры.",
    code: "Код: TRY | Действует до 31 декабря",
    buttonText: "Попробовать сейчас",
    disclaimer: "Не суммируется с другими предложениями. Бесплатная экономичная доставка применяется при покупке минимум 2 разных товаров.",
    images: [slider01, slider02, slider03, slider04],
  },
  {
    badge: null,
    title: "Комплексный подход к вашему бренду",
    description: "Создаем креативные стратегии и реализуем их на практике. Получите бесплатную консультацию при заказе двух и более услуг до конца месяца.",
    code: "Код: BRAND2024 | До 31 декабря",
    buttonText: "Получить бонус",
    disclaimer: "Не суммируется с другими акциями. Бесплатная консультация доступна при заказе от 2-х услуг.",
    images: [slider01, slider02, slider03],
  },
  {
    badge: null,
    title: "Создайте уникальный дизайн для вашего бизнеса",
    description: "Профессиональный дизайн, который выделит вас среди конкурентов. Индивидуальный подход к каждому проекту.",
    code: "Код: DESIGN2024 | До 31 декабря",
    buttonText: "Заказать дизайн",
    disclaimer: "Персональный менеджер и 3 варианта дизайна в подарок.",
    images: [slider01, slider02],
  },
  {
    badge: null,
    title: "Комплексное продвижение в социальных сетях",
    description: "Ведение социальных сетей, создание контента, настройка таргетированной рекламы. Работаем с Instagram, TikTok, VK, Telegram.",
    code: "Код: SMM2024 | До 31 декабря",
    buttonText: "Начать продвижение",
    disclaimer: "Бесплатный аудит аккаунтов и стратегия продвижения.",
    images: [slider01, slider02, slider03, slider04],
  }
];

const Icon = ({ name, size = 16 }) => {
  const common = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "shrink-0",
  };

  const paths = {
    arrow: <><path d="M5 12h13" /><path d="m13 6 6 6-6 6" /></>,
  };

  return <svg {...common}>{paths[name]}</svg>;
};

const PromoSlider = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [progress, setProgress] = useState(0);

  const SLIDE_DURATION = 5000;
  const STEP = 50;

  const handleDotClick = (index) => {
    setActiveSlide(index);
    setProgress(0);
  };

  const nextSlide = () => {
    setActiveSlide((prev) => (prev + 1) % slidesData.length);
    setProgress(0);
  };

  const prevSlide = () => {
    setActiveSlide((prev) => (prev - 1 + slidesData.length) % slidesData.length);
    setProgress(0);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => prev + STEP);
    }, STEP);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (progress >= SLIDE_DURATION) {
      nextSlide();
    }
  }, [progress]);

  const currentSlide = slidesData[activeSlide];
  const currentImages = currentSlide.images;

  const getGridClass = (count) => {
    if (count >= 4) return "grid-cols-2 grid-rows-2";
    if (count === 3) return "grid-cols-3 grid-rows-1";
    if (count === 2) return "grid-cols-2 grid-rows-1";
    return "grid-cols-1 grid-rows-1";
  };

  return (
    <section className="overflow-hidden bg-[#17191d] text-white">
      <div className="mx-auto max-w-[1440px] px-5 lg:px-12">
        <div className="grid h-[360px] grid-cols-1 items-start gap-8 py-7 lg:grid-cols-[.9fr_1.1fr]">
          
          {/* Левая часть */}
          <div className="flex h-[300px] flex-col justify-between">
            <div>
              <div className={`h-4 text-[10px] font-normal uppercase tracking-[.2em] text-accent ${!currentSlide.badge ? "invisible select-none" : ""}`}>
                {currentSlide.badge || "Бейдж"}
              </div>

              <h2 className="mt-1 flex h-[68px] items-start text-2xl font-light leading-tight tracking-wide text-white sm:text-3xl lg:text-[30px]">
                {currentSlide.title}
              </h2>

              <p className="mt-2 h-[58px] max-w-[500px] text-[13px] font-light leading-relaxed text-white/70">
                {currentSlide.description}
              </p>

              <p className="mt-1.5 text-[11px] font-normal text-accent">
                {currentSlide.code}
              </p>

              <div className="mt-3 flex flex-wrap items-center gap-3">
                <button className="shine inline-flex items-center gap-2 rounded-lg bg-accent px-5 py-2 text-[12px] font-medium text-white transition hover:bg-accent-hover">
                  {currentSlide.buttonText} <Icon name="arrow" size={14} />
                </button>
              </div>

              <p className="mt-2 line-clamp-1 max-w-lg text-[10px] font-light leading-tight text-white/40">
                {currentSlide.disclaimer}
              </p>
            </div>

            <div className="flex items-center justify-between pt-2">
              <div className="flex items-center gap-2.5">
                {slidesData.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => handleDotClick(index)}
                    className="relative flex h-1.5 items-center justify-center transition-all duration-500"
                  >
                    {index === activeSlide ? (
                      <div className="relative h-[2px] w-12 overflow-hidden rounded-full bg-surface/20">
                        <div
                          className="absolute left-0 top-0 h-full rounded-full bg-accent"
                          style={{
                            width: `${(progress / SLIDE_DURATION) * 100}%`,
                            transition: `width ${STEP}ms linear`,
                          }}
                        />
                      </div>
                    ) : (
                      <div className="h-[2px] w-6 rounded-full bg-surface/20 transition-colors hover:bg-surface/40" />
                    )}
                  </button>
                ))}
                <span className="ml-2 min-w-[40px] text-[10px] font-light text-white/40">
                  0{activeSlide + 1} / 0{slidesData.length}
                </span>
              </div>

              <div className="flex min-w-[60px] justify-end gap-1.5">
                <button
                  onClick={prevSlide}
                  className="rounded-full border border-line/15 p-1.5 text-white/70 transition hover:border-line/50 hover:bg-surface/5 hover:text-white"
                  aria-label="Предыдущий слайд"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M15 18l-6-6 6-6" />
                  </svg>
                </button>
                <button
                  onClick={nextSlide}
                  className="rounded-full border border-line/15 p-1.5 text-white/70 transition hover:border-line/50 hover:bg-surface/5 hover:text-white"
                  aria-label="Следующий слайд"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </button>
              </div>
            </div>
          </div>

          {/* Правая часть - убран grayscale */}
          <div className={`grid ${getGridClass(currentImages.length)} h-[300px] gap-2.5`}>
            {currentImages.map((img, idx) => (
              <div
                key={`${activeSlide}-${idx}`}
                className="group relative overflow-hidden rounded-xl bg-[#2a2d33]"
              >
                <img
                  src={img}
                  alt={`Слайд ${activeSlide + 1} Изображение ${idx + 1}`}
                  className="h-full w-full object-cover transition duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-x-0 bottom-0 p-3">
                  <div className="text-[11px] font-normal tracking-wide text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                    {["Вывески", "Объёмные буквы", "Световые короба", "Оформление транспорта"][idx] || "Продукция"}
                  </div>
                </div>
              </div>
            ))}
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default PromoSlider;